import NoteAndDocument from "../../../../../../components/noteAndDocument/NoteAndDocument";
import { ExternalTransportNotesSectionProps } from "../externalTransport.types";

const ExternalTransportNotesSection = ({
  notesRef,
  parentId,
  disabled
}: ExternalTransportNotesSectionProps) => (
  <NoteAndDocument
    parentId={parentId}
    ref={notesRef}
    isDisabled={disabled}
    showSaveButton={false}
  />
);

export default ExternalTransportNotesSection;
